module.exports = __webpack_public_path__ + "img/capability-app-tablet.048c585b.png";